'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var React = require('react');
var IconBase = require('@ali/vu-icon-base');

function Popup(props) {
  return React.createElement(
    IconBase,
    _extends({ viewBox: '0 0 1024 1024' }, props),
    React.createElement('path', { d: 'M968.00128 152.86784 215.11168 152.86784c-29.70112 0-53.77792 24.07936-53.77792 53.79072l0 215.10784L0 529.32096l161.33376 107.55456 0 215.12192c0 29.69856 24.0768 53.77536 53.77792 53.77536l752.8896 0c29.70112 0 53.77792-24.0768 53.77792-53.77536l0-645.3376C1021.7792 176.9472 997.70368 152.86784 968.00128 152.86784zM403.3344 609.99296c-44.54912 0-80.66688-36.11776-80.66688-80.672 0-44.55552 36.11776-80.672 80.66688-80.672 44.54912 0 80.66688 36.11776 80.66688 80.672C484.00128 573.87648 447.88352 609.99296 403.3344 609.99296zM779.77856 609.99296c-44.55168 0-80.66688-36.11776-80.66688-80.672 0-44.55552 36.11392-80.672 80.66688-80.672s80.66688 36.11776 80.66688 80.672C860.44544 573.87648 824.33152 609.99296 779.77856 609.99296z' })
  );
}
Popup.displayName = 'Popup';

module.exports = Popup;


//////////////////
// WEBPACK FOOTER
// ./~/_@ali_ve-icons@4.1.6@@ali/ve-icons/build/svglib/popup.js
// module id = 199
// module chunks = 0